<template>
    <div class="margin-right-20 margin-right-s-0">
        <button
            type="button"
            class="button button--primary button--medium width-s-100 margin-bottom-s-20"
            :data-gtm="dataGtm"
            @click="clickModalButton(!isOpen)"
            @keyup.enter="clickModalButton(!isOpen)">
            {{ buttonTitle }}
            <svg
                class="marketDirectoryArrow margin-left-10"
                width="10"
                height="10"
                aria-hidden="true">
                <use href="#iconChevronRightSmall" />
            </svg>
        </button>
        <Modal
            :modal-open="isOpen"
            :has-overlay="false"
            :custom-container-classes="getContainerClasses"
            :custom-close-button-classes="closeButtonClasses"
            @toggle-modal="toggleModal">
            <MarketDirectory
                v-if="marketData"
                :market-data="getMarketDirectoryData"
                :active-outlook="activeOutlook"
                :is-open="isOpen" />
            <RegionsDirectory
                v-else
                :is-open="isOpen" />
        </Modal>
    </div>
</template>

<script>
    import Modal from 'components/modal';
    import Translator from 'tools/trans';
    import MarketDirectory from 'outlook/components/hubPage/marketDirectory';
    import RegionsDirectory from 'outlook/components/marketHighlights/regionsDirectory';
    import { mapState } from 'vuex';

    export default {
        components: {
            Modal,
            MarketDirectory,
            RegionsDirectory,
        },
        props: {
            marketData: {
                type: Object,
                default: null,
            },
            overlayShown: {
                type: Boolean,
                required: true,
            },
            activeOutlook: {
                type: Object,
                default: null,
            },
            buttonTitle: {
                type: String,
                required: true,
            },
            dataGtm: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                isOpen: false,
                hideClose: true,
                modalContainerClasses: [],
                closeButtonClasses: this.hideClose ? ['display-none'] : [],
            };
        },
        computed: {
            ...mapState([
                'marketDirectory',
            ]),
            getContainerClasses() {
                if (this.marketData) {
                    return ['marketDirectory--container'];
                }

                return ['regionDirectory--container'];
            },
            getMarketDirectoryData() {
                if (this.marketDirectory && Object.keys(this.marketDirectory).length > 0) {
                    return this.marketDirectory;
                }

                return this.marketData;
            },
        },
        watch: {
            isOpen(value) {
                this.$emit('is-open', value);
            },
            overlayShown(value) {
                if (!value) {
                    this.toggleModal(false);
                }
            },
        },
        methods: {
            trans: Translator.trans,
            clickModalButton(value) {
                this.toggleModal(value);
            },
            toggleModal(value) {
                if (value === 'close') {

                    return this.isOpen = false;
                }
                this.isOpen = value;
            },
        },
    };
</script>
